"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAIGeneratorButton = exports.csrfToken = exports.removeNewlines = exports.extractText = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var domParser = new DOMParser();

var extractText = function extractText(html) {
  return domParser.parseFromString(html, 'text/html').documentElement.innerText;
};

exports.extractText = extractText;

var removeNewlines = function removeNewlines(html) {
  return html.replace(/<br>/gi, '');
};

exports.removeNewlines = removeNewlines;

var csrfToken = function csrfToken() {
  var element = document.querySelector('meta[name=csrf-token]');
  return element ? element.content : null;
};

exports.csrfToken = csrfToken;

var addAIGeneratorButton = function addAIGeneratorButton(buttonsSettings, anchorButton) {
  var anchorButtonIndex = buttonsSettings.buttons.indexOf(anchorButton) + 1;
  return {
    buttons: [].concat(_toConsumableArray(buttonsSettings.buttons.slice(0, anchorButtonIndex)), ['aiGenerator'], _toConsumableArray(buttonsSettings.buttons.slice(anchorButtonIndex, buttonsSettings.buttons.length))),
    buttonsVisible: buttonsSettings.buttonsVisible + 1
  };
};

exports.addAIGeneratorButton = addAIGeneratorButton;